import { ITranslateObject, SupportedLanguage } from "@app/views-interfaces";

interface CompareByFirstAndLastNames {
    FirstName: string;
    LastName: string;
}

type CompareByActiveAndName = CompareByFirstAndLastNames & { Active: boolean };

const collatorCompare = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

export function compareByFirstAndLastNames<T extends CompareByFirstAndLastNames>(a: T, b: T): number {
    return collatorCompare.compare(a.FirstName || "", b.FirstName || "") || collatorCompare.compare(a.LastName || "", b.LastName || "");
}

export function compareByActiveAndName<T extends CompareByActiveAndName>(a: T, b: T): number {
    return Number(b.Active) - Number(a.Active) || compareByFirstAndLastNames(a, b);
}

type CompareByLocalizedNameNoneFirst = ITranslateObject & { Id: number | string };

export function compareByLocalizedName<T extends ITranslateObject>(a: T, b: T, language: SupportedLanguage): number {
    return compareString(a[language] || "", b[language] || "");
}

export function compareByLocalizedNameNoneFirst<T extends CompareByLocalizedNameNoneFirst>(a: T, b: T, language: SupportedLanguage): number {
    if (a.Id === -1) return -1;
    if (b.Id === -1) return 1;
    return compareByLocalizedName(a, b, language);
}

export function compareString(a: string, b: string, dir: "asc" | "desc" = "asc"): number {
    if (a === b) return 0;
    if (!a) return dir === "asc" ? -1 : 1;
    if (!b) return dir === "asc" ? 1 : -1;
    const result = collatorCompare.compare(a || "", b || "");
    return dir === "asc" ? result : -result;
}
